export const CATALOG_VISIBLE_IMAGE_COUNT = 3;
export const IMAGE_ROTATION_INTERVAL_MS = 4500;
export const IMAGE_TRANSITION_DURATION_MS = 500;
